import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import RoleBasedRoute from "./RoleBasedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";

const Routes = () => {
  const { token, userType } = useSelector((state) => state.auth);

  // Get role-specific dashboard
  const getDashboardPath = () => {
    const dashboardMap = {
      truck_owner: `${APP_PREFIX_PATH}/truck_owner/home`,
      mechanic: `${APP_PREFIX_PATH}/mechanic/dashboard`,
      fleet_manager: `${APP_PREFIX_PATH}/fleet-dashboard/home`,
      driver: `${APP_PREFIX_PATH}/driver/home`,
    };

    return dashboardMap[userType] || `${APP_PREFIX_PATH}/fleet-dashboard/home`;
  };

  // Root redirect component
  const RootRedirect = () => {
    if (!token) {
      return <Navigate to={`${AUTH_PREFIX_PATH}/role-selection`} replace />;
    }

    const dashboardPath = getDashboardPath();
    return <Navigate to={dashboardPath} replace />;
  };

  return (
    <RouterRoutes>
      <Route path="/" element={<RootRedirect />} />

      <Route path="/" element={<ProtectedRoute />}>
        {protectedRoutes.map((route, index) => {
          const hasWildcard = route.path.endsWith("/*");

          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <RoleBasedRoute
                  allowedRoles={route.meta?.allowedRoles || []}
                  requiresVerification={
                    route.meta?.requiresVerification || false
                  }
                />
              }
            >
              <Route
                path={hasWildcard ? "*" : undefined}
                index={!hasWildcard}
                element={
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                    {...route.meta}
                  />
                }
              />
            </Route>
          );
        })}

        <Route
          path="*"
          element={
            <Navigate
              to={token ? getDashboardPath() : `${AUTH_PREFIX_PATH}/role-selection`}
              replace
            />
          }
        />
      </Route>

      {/* Public Routes - login, register, etc */}
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
